var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.navComponent,{tag:"component",attrs:{"wrapper-class":_vm.wrapperClass,"nav-items":_vm.navItems,"is-tier3-at-mobile":_vm.isTier3AtMobile,"tier3-nav":_vm.tier3Nav}})}
var staticRenderFns = []

export { render, staticRenderFns }